import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { store, type RootState } from '../../../stateManagement/store'
import { getItemWebStorage } from '../../../features/webStorageSaver'
import { logoutApp } from '../../../features/auth/logout'
import { showToastMessage } from '../../../stateManagement/reducers'

const baseQuery = fetchBaseQuery({
    baseUrl: `/`,
    prepareHeaders: (headers, { getState }) => {
        let token = (getState() as RootState).auth.tokens.app
        try {
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        } catch (error) {

        }
    }
})

const dynamicBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const urlEnd = typeof args === 'string' ? args : args.url
    const currentApiUrl = getItemWebStorage("currentApiUrl")

    let adjustedUrl = `${currentApiUrl}/${urlEnd}`

    // кастомная сериализация params (пробел -> %20, без '+')
    if (typeof args !== 'string' && (args as FetchArgs)?.params) {
        const raw = (args as FetchArgs).params as Record<string, any>
        const parts: string[] = []
        for (const [k, v] of Object.entries(raw)) {
            if (v === undefined || v === null || v === '') continue
            if (Array.isArray(v)) {
                v.forEach(iv => parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(iv))}`))
            } else if (typeof v === 'object') {
                parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(JSON.stringify(v))}`)
            } else {
                parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
            }
        }
        if (parts.length) adjustedUrl += (adjustedUrl.includes('?') ? '&' : '?') + parts.join('&')
    }

    const adjustedArgs = typeof args === 'string'
        ? adjustedUrl
        : { ...(args as FetchArgs), currentApiUrl, url: adjustedUrl, params: undefined as any }

    const result: any = await baseQuery(adjustedArgs, api, extraOptions)
    if (result.error) {
        const { originalStatus, status } = result?.error ?? {}
        if (originalStatus === 401 || status === 401) {
            setTimeout(() => store.dispatch(showToastMessage({ messageText: "Данные авторизации устарели. Авторизуйтесь снова", messageType: "error" })), 500)
            logoutApp()
        }
    }
    return result;
}

export const baseAPI = createApi({
    reducerPath: 'baseAPI',
    baseQuery: dynamicBaseQuery,
    endpoints: builder => ({}),
})

export const baseAPIReducer = baseAPI.reducer
export const resetBaseAPI = baseAPI.util.resetApiState